export default __webpack_public_path__ + "static/media/maxIcon.ced400c1.png";